import * as LabelPrimitive from '@radix-ui/react-label';
import type * as React from 'react';
import { cn } from '@/lib/utils';

/** Rótulo de campo: eyebrow mono maiúsculo (manual §2 e §4). */
export function Label({ className, ...p }: React.ComponentProps<typeof LabelPrimitive.Root>) {
  return <LabelPrimitive.Root className={cn('tipo-rotulo', className)} {...p} />;
}
